import {Component, DestroyRef, ElementRef, inject, OnDestroy, OnInit, ViewChild,} from '@angular/core';
import * as UIExtension from '@foxitsoftware/foxit-pdf-sdk-for-web-library/lib/UIExtension.full.js';
import * as PDFViewCtrl from '@foxitsoftware/foxit-pdf-sdk-for-web-library/lib/PDFViewCtrl.full.js';
import license from './license-key.js';
import {DokumentDataService} from '../services/dokument-data.service';
import {MessageBoxService} from '../services/message-box.service';
import {DokumentModels} from '../models/dokument-models';
import {ActivatedRoute, Router} from '@angular/router';
import {ObjektDataService} from '../services/objekt-data.service';
import {AnnotationStorageServiceService} from '../services/annotation-storage-service.service';
import {UserAuthenticationService} from '../services/user-authentication.service';
import {HelperService} from '../services/helper.service';
import {AnnotationFlags} from 'pdf-lib';
import {CameraViewerComponent} from '../home-layout/camera-viewer/camera-viewer.component';
import {MatDialog} from '@angular/material/dialog';
import {DeviceDetectionService} from '../services/device-detection-service';
import {LocalStorageService} from '../local-storage.service';
import {DocumentManagementService} from '../services/document-management.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {v4 as uuidv4} from 'uuid';
import {Platform} from '@angular/cdk/platform';
import {HttpStatusCode} from '@angular/common/http';
import DokumentInfo = DokumentModels.DokumentInfo;

const MAX_IMG_WIDTH = 600;  // keep around a4 format (21/29)
const MAX_IMG_HEIGHT = 957; // keep around a4 format (21/29)

/* eslint-disable no-string-literal */
class SwissSoftTemplate extends UIExtension.appearances.AdaptiveAppearance {
    protected getLayoutTemplate(): string {
        return '' +
            // eslint-disable-next-line
            '<webpdf>\r\n\t<div class=\"fv__ui-mobile-header\" name=\"fv--mobile-header\" style=\"z-index: 999;\">\r\n\t\t<div class=\"fv__ui-mobile-header-left\" name=\"fv--mobile-header-left\">\r\n\t\t\t<mobile:sidebar-toggler-button name=\"fv--mobile-sidebar-toggler-button\"><\/mobile:sidebar-toggler-button>\r\n\t\t\t<!--Pencil Tab-->\r\n\t\t\t<li @on.click=\"mtab.switchTab($component)\" id=\"draw-tab-li\" name=\"draw-tab-li\">\r\n\t\t\t\t<gtab active body=\"draw-tab-body\" class=\"fv__ui-button-icon fv__icon-toolbar-pencil header\" group=\"mobile-tab\" name=\"draw-tab\"><\/gtab>\r\n\t\t\t<\/li>\r\n\t\t\t<!-- Marker Tab-->\r\n\t\t\t<li @on.click=\"mtab.switchTab($component)\" id=\"marker-tab-li\" name=\"marker-tab-li\">\r\n\t\t\t\t<gtab body=\"marker-tab-body\" class=\"fv__ui-button-icon fv__icon-toolbar-text-highlight header\" group=\"mobile-tab\" name=\"marker-tab\"><\/gtab>\r\n\t\t\t<\/li>\r\n\t\t\t<!-- Textfield Tab-->\r\n\t\t\t<li @on.click=\"mtab.switchTab($component)\" id=\"text-tab-li\" name=\"text-tab-li\">\r\n\t\t\t\t<gtab body=\"text-tab-body\" class=\"fv__ui-button-icon fv__icon-toolbar-textbox header\" group=\"mobile-tab\" name=\"text-tab\"><\/gtab>\r\n\t\t\t<\/li>\r\n\t\t\t<!--Forms Tab-->\r\n\t\t\t<li @on.click=\"mtab.switchTab($component)\" id=\"forms-tab-li\" name=\"forms-tab-li\">\r\n\t\t\t\t<gtab body=\"forms-tab-body\" class=\"fv__ui-button-icon fv__icon-toolbar-square header\" group=\"mobile-tab\" name=\"forms-tab\"><\/gtab>\r\n\t\t\t<\/li>\r\n\t\t\t<!--\r\n\t\t\t<li @on.click=\"mtab.switchTab($component)\" name=\"measurement-tab-li\">\r\n\t\t\t\t<gtab name=\"measurement-tab\" group=\"mobile-tab\" body=\"measurement-tab-body\" class=\"fv__ui-button-icon fv__icon-toolbar-perimeter header\"><\/gtab>\r\n\t\t\t<\/li>\r\n\t\t-->\r\n\t\t\t<!--Stamps-->\r\n\t\t\t<li class=\"btn\">\r\n\t\t\t\t<stamp-ribbon-dropdown align=\"client-center\" id=\"stamp-tab-li\"><\/stamp-ribbon-dropdown>\r\n\t\t\t<\/li>\r\n\t\t<\/div>\r\n\t\t<div class=\"fv__ui-mobile-header-main\" name=\"fv--mobile-header-main\">\r\n\t\t\t<group name=\"home-tab-group-nav\">\r\n\t\t\t\t<goto-first-page-button><\/goto-first-page-button>\r\n\t\t\t\t<goto-prev-page-button><\/goto-prev-page-button>\r\n\t\t\t\t<goto-page-input><\/goto-page-input>\r\n\t\t\t\t<goto-next-page-button><\/goto-next-page-button>\r\n\t\t\t\t<goto-last-page-button id=\"gotoLastPage\"><\/goto-last-page-button>\r\n\t\t\t<\/group>\r\n\t\t<\/div>\r\n\t\t<div class=\"fv__ui-mobile-header-right\" name=\"fv--mobile-header-right\">\r\n\t\t\t<xbutton @controller=\"states:HandController\" icon-class=\"fv__icon-toolbar-hand fv__ui-button-icon header\" id=\"hand-tool-header\" name=\"hand-tool\"><\/xbutton>\r\n\r\n\t\t\t<xbutton @controller=\"undo:UndoController\" icon-class=\"fv__icon-toolbar-undo\" id=\"undoButton\" name=\"undo\"><\/xbutton>\r\n\t\t\t<xbutton @controller=\"redo:RedoController\" icon-class=\"fv__icon-toolbar-redo\" id=\"redoButton\" name=\"redo\"><\/xbutton>\r\n\r\n\t\t\t<mobile:pageview-dropdown @selectable-dropdown=\"1\" class=\"page-view-dropdown\" name=\"fv--mobile-pageview-dropdown\">\r\n\t\t\t\t<xbutton @controller=\"pagemode:ContinuousPageModeController\" icon-class=\"fv__icon-toolbar-continuous-page\" name=\"continuous-page\"><\/xbutton>\r\n\t\t\t\t<xbutton @controller=\"pagemode:SinglePageModeController\" icon-class=\"fv__icon-toolbar-single-page\" name=\"single-page\"><\/xbutton>\r\n\t\t\t\t<!--<facing-page-button><\/facing-page-button>-->\r\n\t\t\t\t<!--<continuous-facing-page-button><\/continuous-facing-page-button>-->\r\n\t\t\t<\/mobile:pageview-dropdown>\r\n\r\n\t\t\t<xbutton @controller=\"zoom:ZoomInAndOutController\" action=\"zoomin\" class=\"zoom-btn\" icon-class=\"fx-icon-ribbon_home_zoomin\" name=\"zoom-in\"><\/xbutton>\r\n\t\t\t<xbutton @controller=\"zoom:ZoomInAndOutController\" action=\"zoomout\" class=\"zoom-btn\" icon-class=\"fx-icon-ribbon_home_zoomout\" name=\"zoom-out\"><\/xbutton>\r\n\t\t\t<xbutton class=\"fv__ui-button-icon addPage\" feature=\"insert\" id=\"addBlankPage\" name=\"contextmenu-item-thumbnail-add-blank-page\"><\/xbutton>\r\n\t\t\t<xbutton class=\"fv__ui-button-icon removePage\" feature=\"delete\" id=\"removePage\" name=\"contextmenu-item-thumbnail-remove-page\"><\/xbutton>\r\n\t\t\t<xbutton @controller=\"mobile:SearchToggleButtonController\" icon-class=\"fv__icon-mobile-topbar-search\" name=\"fv--mobile-topbar-search-button\"><\/xbutton>\r\n\t\t\t<xbutton icon-class=\"fv__icon-mobile-topbar-save\" id=\"save-file-button\" name=\"save-file-button\"><\/xbutton>\r\n\t\t\t<!--<xbutton name=\"download-file-button\" icon-class=\"fv__icon-mobile-topbar-download\" @controller=\"file:DownloadFileController\"><\/xbutton>-->\r\n\t\t\t<xbutton icon-class=\"fv__icon-mobile-topbar-close\" id=\"close-file-button\" name=\"close-file-button\"><\/xbutton>\r\n\t\t<\/div>\r\n\t<\/div>\r\n\t<toolbar style=\"z-index: 998; background-color: white;\">\r\n\t\t<div class=\"fv__ui-mobile-tab-bodies\" id=\"fv--mobile-toolbar-tabs\" name=\"fv--mobile-toolbar-tabs\">\r\n\t\t\t<div class=\"fv__ui-mobile-tab-body\" name=\"draw-tab-body\">\r\n\t\t\t\t<group-list shrink-size=\"-1\">\r\n\t\t\t\t\t<!--Colors-->\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"ink\" id=\"backgroundColorSettingsButton\" name=\"backgroundColorSettingsButton\"\r\n\t\t\t\t\t\t         style=\"background-color: rgba(100, 100, 100, 0.5); border-style: solid;\">X\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:HandController\" icon-class=\"fv__icon-mobile-topbar-hand btn\" id=\"hand-tool\" name=\"hand-tool\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreatePencilController\" icon-class=\"fx-icon-sm fv__icon-toolbar-pencil\" id=\"pencil-tool\" name=\"pencil-tool\" ribbon-icon=\"fv__icon-toolbar-pencil\">\r\n\t\t\t\t\t\t\ttoolbar.buttons.pencil\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t\t<!--<xbutton id=\"pencil\" name=\"pencil\" icon-class=\"fx-icon-sm fv__icon-toolbar-pencil custom\" ribbon-icon=\"fv__icon-toolbar-pencil\">toolbar.buttons.pencil<\/xbutton>-->\r\n\t\t\t\t\t\t<!--<xbutton id=\"custom-pencil-tool\" name=\"custom-pencil-tool\" icon-class=\"fx-icon-sm fv__icon-toolbar-pencil\" ribbon-icon=\"fv__icon-toolbar-pencil\">toolbar.buttons.pencil\t\t\t\t\t\t<\/xbutton>-->\r\n\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t<xbutton id=\"hand-blocker\" name=\"hand-blocker\" icon-class=\"fx-icon-sm fv__icon-toolbar-pencil\" ribbon-icon=\"fv__icon-toolbar-pencil\"\r\n\t\t\t\t\t\t         style=\"color: red; background-color: yellow\">toolbar.buttons.pencil\r\n\t\t\t\t\t\t<\/xbutton>-->\r\n\t\t\t\t\t\t<!--<xbutton id=\"pencil-mode\" name=\"pencil-mode\" icon-class=\"fx-icon-sm fv__icon-toolbar-pencil\" ribbon-icon=\"fv__icon-toolbar-pencil\" style=\"color: purple; background-color: green\">toolbar.buttons.pencil<\/xbutton>-->\r\n\r\n\t\t\t\t\t\t<xbutton @controller=\"states:EraserController\" icon-class=\"fx-icon-sm fv__icon-toolbar-eraser\" id=\"eraser-tool\" name=\"eraser-tool\" ribbon-icon=\"fv__icon-toolbar-eraser\">\r\n\t\t\t\t\t\t\ttoolbar.buttons.eraser\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t\t<!--Notes--\r\n\t\t\t\t\t\t<li class=\"btn\">\r\n\t\t\t\t\t\t\t<create-note-ribbon-button><\/create-note-ribbon-button>\r\n\t\t\t\t\t\t<\/li>-->\r\n\t\t\t\t\t\t<xbutton icon-class=\"fv__icon-toolbar-image\" id=\"create-custom-image\" name=\"create-custom-image\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton icon-class=\"fv__icon-toolbar-image camera\" id=\"create-custom-image-camera\" name=\"create-custom-image-camera\"><\/xbutton>\r\n\r\n\t\t\t\t\t\t<div class=\"hand-blocker-controls\">\r\n\t\t\t\t\t\t\t<div style=\"display: flex; flex-direction:row;\">\r\n\t\t\t\t\t\t\t\t<div id=\"handBlockerText\" style=\"line-height:19px; user-select: none;\">Handablagefl\u00E4che<\/div>\r\n\t\t\t\t\t\t\t\t<input checked id=\"handBlocker\" name=\"handBlocker\" style=\"width: 19px; height:19px; margin: 0 4px;\" type=\"checkbox\"\/>\r\n\t\t\t\t\t\t\t<\/div>\r\n\t\t\t\t\t\t\t<label class=\"switch\" id=\"handBlockerSideElement\">\r\n\t\t\t\t\t\t\t\t<input checked id=\"handBlockerSide\" type=\"checkbox\">\r\n\t\t\t\t\t\t\t\t<span class=\"slider round\"><\/span>\r\n\t\t\t\t\t\t\t<\/label>\r\n\t\t\t\t\t\t\t<span class=\"material-symbols-outlined\" id=\"increaseBlockerSize\" style=\"padding:4px;\">\r\n\t\t\t\t\t\t\t\tev_shadow_add\r\n\t\t\t\t\t\t\t<\/span>\r\n\t\t\t\t\t\t\t<span class=\"material-symbols-outlined\" id=\"decreaseBlockerSize\" style=\"padding:4px;\">\r\n\t\t\t\t\t\t\t\tev_shadow_minus\r\n\t\t\t\t\t\t\t<\/span>\r\n\t\t\t\t\t\t<\/div>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t<\/group-list>\r\n\t\t\t<\/div>\r\n\t\t\t<div class=\"fv__ui-mobile-tab-body\" name=\"marker-tab-body\">\r\n\t\t\t\t<group-list shrink-size=\"-1\">\r\n\t\t\t\t\t<!--Colors-->\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"marker\" id=\"backgroundColorSettingsButton\" name=\"backgroundColorSettingsButton\"\r\n\t\t\t\t\t\t         style=\"background-color: rgba(100, 100, 100, 0.5); border-style: solid;\">X\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:HandController\" icon-class=\"fv__icon-mobile-topbar-hand btn\" name=\"hand-tool\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateHighlightController\" icon-class=\"fx-icon-sm fv__icon-toolbar-text-highlight\" name=\"create-highlight\"\r\n\t\t\t\t\t\t         ribbon-icon=\"fx-icon-ribbon_home_highlight-32\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateUnderlineController\" icon-class=\"fx-icon-sm fv__icon-toolbar-underline\" name=\"create-underline\"\r\n\t\t\t\t\t\t         ribbon-icon=\"fx-icon-ribbon_home_underline-32\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateAreaHighlightController\" icon-class=\"fx-icon-sm fx-icon-ribbon_comment_area_highlight-16\" name=\"create-area-highlight\"\r\n\t\t\t\t\t\t         ribbon-icon=\"fv__icon-toolbar-area-highlight\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateStrikeoutController\" @tooltip icon-class=\"fx-icon-sm fv__icon-toolbar-strikeout\" name=\"create-strikeout\"\r\n\t\t\t\t\t\t         ribbon-icon=\"fx-icon-ribbon_comment_strikeout-32\" ribbon-text=\"toolbar.tooltip.strikeout.title\" tooltip-title=\"toolbar.tooltip.strikeout.title\">\r\n\t\t\t\t\t\t\ttoolbar.create.strikeout\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateSquigglyController\" @tooltip icon-class=\"fx-icon-sm fv__icon-toolbar-squiggly\" name=\"create-squiggly\"\r\n\t\t\t\t\t\t         ribbon-icon=\"fx-icon-ribbon_comment_underline-32\" ribbon-text=\"toolbar.tooltip.squiggly.title\" tooltip-title=\"toolbar.tooltip.squiggly.title\">toolbar.create.squiggly\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t<\/group-list>\r\n\t\t\t<\/div>\r\n\r\n\t\t\t<div class=\"fv__ui-mobile-tab-body\" name=\"text-tab-body\">\r\n\t\t\t\t<group-list shrink-size=\"-1\">\r\n\t\t\t\t\t<!--Colors-->\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"text\" id=\"inkColorSettingsButton\" name=\"inkColorSettingsButton\" style=\"background-color: white; border: 2px solid black;\">X<\/xbutton>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"text\" id=\"backgroundColorSettingsButton\" name=\"backgroundColorSettingsButton\"\r\n\t\t\t\t\t\t         style=\"background-color: rgba(100, 100, 100, 0.5); border-style: solid;\">X\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"text\" id=\"borderColorSettingsButton\" name=\"borderColorSettingsButton\"\r\n\t\t\t\t\t\t         style=\"background-color: rgba(100, 100, 100, 0.5); border-style: solid;\">X\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:HandController\" icon-class=\"fv__icon-mobile-topbar-hand btn\" name=\"hand-tool\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateTextboxController\" icon-class=\"fx-icon-sm fv__icon-toolbar-textbox\" name=\"freetext-textbox\" ribbon-icon=\"fv__icon-toolbar-textbox\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateTypewriterController\" icon-class=\"fx-icon-sm fv__icon-toolbar-typewriter\" name=\"freetext-typewriter\"\r\n\t\t\t\t\t\t         ribbon-icon=\"fv__icon-toolbar-typewriter\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateCalloutController\" icon-class=\"fx-icon-sm fv__icon-toolbar-callout\" name=\"freetext-callout\" ribbon-icon=\"fv__icon-toolbar-callout\"><\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group style=\"display: none\">\r\n\t\t\t\t\t\t<xbutton class=\"fx-icon fv__icon-addon-textobject-bold\" id=\"text-bold\" name=\"text-bold\"><\/xbutton>\r\n\t\t\t\t\t\t<xbutton class=\"fx-icon fv__icon-addon-textobject-italic\" id=\"text-italic\" name=\"text-italic\"><\/xbutton>\r\n\r\n\t\t\t\t\t\t<div class=\"fv__ui-custom-input-element\" style=\"display: flex; flex-direction: column;\">\r\n\t\t\t\t\t\t\t<span>Textgr\u00F6sse<\/span>\r\n\t\t\t\t\t\t\t<div style=\"display: flex; flex-direction: row;\">\r\n\t\t\t\t\t\t\t\t<input id=\"text-size-input\" max=\"100\" min=\"1\" name=\"text-size\" style=\"flex: 1;\" type=\"number\" value=\"12\"><\/input>\r\n\t\t\t\t\t\t\t\t<input id=\"text-size-slider\" max=\"100\" min=\"1\" name=\"text-size\" style=\"flex: 2;\" type=\"range\" value=\"12\"><\/input>\r\n\t\t\t\t\t\t\t<\/div>\r\n\t\t\t\t\t\t<\/div>\r\n\t\t\t\t\t\t<div class=\"fv__ui-custom-input-element\" style=\"display: flex; flex-direction: column;\">\r\n\t\t\t\t\t\t\t<span>Schriftart<\/span>\r\n\t\t\t\t\t\t\t<select id=\"text-font-select\" name=\"text-font-select\">\r\n\t\t\t\t\t\t\t\t<option value=\"Helvetica\">Helvetica<\/option>\r\n\t\t\t\t\t\t\t\t<option value=\"Roboto\">Roboto<\/option>\r\n\t\t\t\t\t\t\t\t<option value=\"sans-serif\">Sans-Serif<\/option>\r\n\t\t\t\t\t\t\t<\/select>\r\n\t\t\t\t\t\t<\/div>\r\n\t\t\t\t\t<\/group>\r\n\r\n\t\t\t\t<\/group-list>\r\n\t\t\t<\/div>\r\n\t\t\t<div class=\"fv__ui-mobile-tab-body\" name=\"forms-tab-body\">\r\n\t\t\t\t<group-list shrink-size=\"-1\">\r\n\t\t\t\t\t<!--Colors-->\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"forms\" id=\"backgroundColorSettingsButton\" name=\"backgroundColorSettingsButton\"\r\n\t\t\t\t\t\t         style=\"background-color: rgba(100, 100, 100, 0.5); border-style: solid;\">X\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t\t<xbutton class=\"color\" data-type=\"forms\" id=\"borderColorSettingsButton\" name=\"borderColorSettingsButton\" style=\"background-color: rgba(100, 100, 100, 0.5); border: 2px solid;\">\r\n\t\t\t\t\t\t\tX\r\n\t\t\t\t\t\t<\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:HandController\" icon-class=\"fv__icon-mobile-topbar-hand btn\" name=\"hand-tool\"><\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateSquareController\" class=\"action-btn square\" icon-class=\"fv__icon-toolbar-square\">square<\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreatePolygonController\" class=\"action-btn polgon\" icon-class=\"fv__icon-toolbar-polygon\">polygon<\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateCircleController\" class=\"action-btn circle\" icon-class=\"fv__icon-toolbar-circle\">circle<\/xbutton>\r\n\t\t\t\t\t\t<!--<xbutton class=\"action-btn cloud\" icon-class=\"fv__icon-toolbar-cloud\" @controller=\"states:CreatePolygonCloudController\">cloud<\/xbutton>-->\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreateArrowController\" class=\"action-btn arrow\" icon-class=\"fv__icon-toolbar-arrow\">arrow<\/xbutton>\r\n\t\t\t\t\t\t<xbutton @controller=\"states:CreatePolylineController\" class=\"action-btn line\" icon-class=\"fv__icon-toolbar-line\">polyline<\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t<\/group-list>\r\n\t\t\t<\/div>\r\n\t\t\t<!--\r\n\r\n\t\t\t<div class=\"fv__ui-mobile-tab-body\" name=\"measurement-tab-body\">\r\n\t\t\t\t<group-list shrink-size=\"-1\">\r\n\t\t\t\t\t<--Colors--\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton class=\"color\" name=\"inkColorSettingsButton\" style=\"background-color: white; border: 2px solid black;\" id=\"inkColorSettingsButton\"><\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<xbutton name=\"hand-tool\" icon-class=\"fv__icon-mobile-topbar-hand btn\" @controller=\"states:HandController\"><\/xbutton>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t\t<group>\r\n\t\t\t\t\t\t<--measurement--\r\n\t\t\t\t\t\t<li class=\"btn\">\r\n\t\t\t\t\t\t\t<dropdown @cannotBeDisabled separate=\"false\" selected=\"0\" class=\"measurment-dropdown fv__ui-button-icon\">\r\n\t\t\t\t\t\t\t\t<xbutton class=\"action-btn custom-action-btn distance\" name=\"create-distance-btn\" icon-class=\"fv__icon-toolbar-perimeter\" @controller=\"distance:CreateDistanceController\" tabindex=\"0\"><\/xbutton>\r\n\t\t\t\t\t\t\t\t<xbutton class=\"action-btn custom-action-btn perimeter\" name=\"create-perimeter-btn\" icon-class=\"fv__icon-toolbar-distance\" @controller=\"distance:CreatePerimeterController\" tabindex=\"0\"><\/xbutton>\r\n\t\t\t\t\t\t\t\t<xbutton class=\"action-btn custom-action-btn area\" name=\"create-area-btn\" icon-class=\"fv__icon-toolbar-area\" @controller=\"distance:CreateAreaController\" tabindex=\"0\"><\/xbutton>\r\n\t\t\t\t\t\t\t\t<xbutton class=\"action-btn custom-action-btn circle\" name=\"create-circle-btn\" icon-class=\"fv__icon-toolbar-areacircle\" @controller=\"distance:CreateCircleAreaController\" tabindex=\"0\"><\/xbutton>\r\n\t\t\t\t\t\t\t<\/dropdown>\r\n\t\t\t\t\t\t<\/li>\r\n\t\t\t\t\t<\/group>\r\n\t\t\t\t<\/group-list>\r\n\t\t\t<\/div>\r\n\t\t\t-->\r\n\t\t<\/div>\r\n\t<\/toolbar>\r\n\t<div class=\"fv__ui-body\">\r\n\t\t<sidebar @controller=\"sidebar:SidebarController\" @mobile:sidebar-toggler name=\"sidebar\" width=\"0.4\">\r\n\t\t\t<commentlist-sidebar-panel><\/commentlist-sidebar-panel>\r\n\t\t\t<thumbnail-sidebar-panel @require-modules=\"thumbnail\"><\/thumbnail-sidebar-panel>\r\n\t\t\t<search-sidebar-panel><\/search-sidebar-panel>\r\n\t\t\t<sidebar-panel class=\"fv__ui-sidebar-nav-ctrl documents-sidebar-panel\" icon-class=\"fv__ui-sidebar-nav-icon documents-sidebar-icon\" title=\"Dokumente\">\r\n\t\t\t\t<div class=\"document-sidebar-content\" id=\"document-sidebar-content\">\r\n\r\n\t\t\t\t<\/div>\r\n\t\t\t<\/sidebar-panel>\r\n\t\t<\/sidebar>\r\n\t\t<viewer @touch-to-scroll @zoom-on-doubletap @zoom-on-pinch><\/viewer>\r\n\t\t<page-nav-button><\/page-nav-button>\r\n\t\t<sidebar-right @lazy-content=\"shown\" min-width=\"150\" name=\"sidebar-right\" width=\"260\">\r\n\t\t\t<sidebar-tabs name=\"sidebar-right-tabs\">\r\n\t\t\t\t<sidebar-tab-panel name=\"edit-properties-panel\" tab-title=\"editProperties.tab.format\">\r\n\t\t\t\t\t<edit-properties:edit-properties name=\"edit-properties\"><\/edit-properties:edit-properties>\r\n\t\t\t\t<\/sidebar-tab-panel>\r\n\t\t\t\t<sidebar-tab-panel name=\"right-search-panel\" tab-title=\"editProperties.tab.search\">\r\n\t\t\t\t\t<search:advanced-search name=\"advanced-search\"><\/search:advanced-search>\r\n\t\t\t\t<\/sidebar-tab-panel>\r\n\t\t\t<\/sidebar-tabs>\r\n\t\t<\/sidebar-right>\r\n\t<\/div>\r\n\r\n\t<template>\r\n\t\t<distance:measurement-popup @lazy><\/distance:measurement-popup>\r\n\t\t<contextmenu @lazy @thumbnail:permission name=\"fv--thumbnail-contextmenu\">\r\n\t\t\t<contextmenu-item @controller=\"thumbnail:RotateLeftController\" feature=\"rotate\" name=\"contextmenu-item-thumbnail-rotate-left\">thumbnail:contextmenu.rotateLeft<\/contextmenu-item>\r\n\t\t\t<contextmenu-item @controller=\"thumbnail:RotateRightController\" feature=\"rotate\" name=\"contextmenu-item-thumbnail-rotate-right\">thumbnail:contextmenu.rotateRight<\/contextmenu-item>\r\n\t\t\t<contextmenu-separator><\/contextmenu-separator>\r\n\t\t\t<contextmenu-item @controller=\"thumbnail:InsertBlankPageController\" feature=\"insert\" name=\"contextmenu-item-thumbnail-add-blank-page\">thumbnail:contextmenu.addBlankPage<\/contextmenu-item>\r\n\t\t\t<contextmenu-separator><\/contextmenu-separator>\r\n\t\t\t<thumbnail:delete-page-contextmenu-item name=\"contextmenu-item-thumbnail-delete\"><\/thumbnail:delete-page-contextmenu-item>\r\n\t\t\t<div><\/div>\r\n\t\t<\/contextmenu>\r\n\t<\/template>\r\n<\/webpdf>\r\n'
            + '';
    }
}

@Component({
    selector: 'app-pdfviewer', templateUrl: './pdfviewer.component.html', styleUrls: ['./pdfviewer.component.scss'],
})
export class PDFViewerComponent implements OnInit, OnDestroy {
    public opacity = 1;
    public color: any;
    @ViewChild('eraserSettings') eraserSettings?: ElementRef<HTMLDivElement>;
    @ViewChild('inkSettings') inkSettings?: ElementRef<HTMLDivElement>;
    @ViewChild('colorSettings') colorSettings?: ElementRef<HTMLDivElement>;
    @ViewChild('inkColorSettings') inkColorSettings?: ElementRef<HTMLDivElement>;
    @ViewChild('colorPicker') colorPicker?: ElementRef<HTMLDivElement>;
    @ViewChild('deletePageDialog') deletePageDialog?: ElementRef<HTMLDivElement>;
    @ViewChild('deletePageTemplateContainer') deletePageTemplateContainer?: ElementRef<HTMLTemplateElement>;
    @ViewChild('closeEditorDialog') closeEditorDialog?: ElementRef<HTMLDivElement>;
    @ViewChild('closeEditorTemplateContainer') closeEditorTemplateContainer?: ElementRef<HTMLTemplateElement>;
    public pdfuiInstance!: UIExtension.PDFUI;
    public readonly objektUrl: any;
    public readonly saUrl: any;
    private viewer!: UIExtension.PDFViewCtrl.PDFViewer;
    private stateHandlerManager: any;
    private windowFunctions: any[] = [];
    private lastTouchEnd = 0;
    private currentUser: any;
    private hasChanges = false;
    private objectUrls: string[] = [];
    private hasLoaded = false;
    private handBlockerActivated = false;
    private blockerSize = 0;
    private timeappDocumentURL: any;
    private returnUrl: string;

    private destroyRef = inject(DestroyRef);
    private documentID = '';
    private isMobile = false;

    constructor(
        public localStorageService: LocalStorageService,
        public deviceDetectionService: DeviceDetectionService,
        public dialog: MatDialog,
        public docService: DokumentDataService,
        private svcMessageBox: MessageBoxService,
        public svcObjekte: ObjektDataService,
        private route: ActivatedRoute,
        private userAuthService: UserAuthenticationService,
        public router: Router,
        private annotationStorage: AnnotationStorageServiceService,
        public helperService: HelperService,
        private documentManagementService: DocumentManagementService,
        private platform: Platform
    ) {
        this.objektUrl = this.route.snapshot.queryParams.returnUrl || '/objekte';
        this.saUrl = this.route.snapshot.queryParams.returnUrl || '/serviceapp/sadocs';
        this.timeappDocumentURL = this.route.snapshot.queryParams.returnUrl || '/timeapp/documents';
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || 'dashboard';
    }

    ngOnInit(): void {
        this.helperService.pausePeriodicalChecks();
        this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (params) => {
                if (params.id) {
                    this.documentID = params.id;
                    this.init(this.documentID);
                } else {
                    this.router.navigate([]);
                }
            },
        });
    }

    async init(documentID: string): Promise<void> {
        localStorage.removeItem('foxit-default-annot-prop');
        try {
            this.isMobile = PDFViewCtrl.DeviceInfo.isMobile;
            const pathToLib = '/foxit-lib/';
            this.pdfuiInstance = new UIExtension.PDFUI({
                viewerOptions: {
                    libPath: pathToLib,
                    jr: {
                        enginePath: pathToLib + 'jr-engine/gsdk/',
                        ...license
                    }
                },
                appearance: SwissSoftTemplate,
                renderTo: document.getElementById('pdf-ui') as HTMLElement,
                addons: pathToLib + (this.isMobile
                    ? 'uix-addons/allInOne.mobile.js'
                    : 'uix-addons/allInOne.js'),
            });
        } catch (ex) {
            console.log(ex);
        }

        // check if document exists to be synced
        const doc = await this.documentManagementService.getDocument(documentID);
        if (doc && doc.file.size > 0) {
            this.docService.setDocumentInfo(doc);
            const pdf = new File([doc.file], doc.fileName);
            await new Promise(resolve => {
                this.docService.uploadDokumentWithInfo(pdf, doc).subscribe({
                    next: async (saveRes) => {
                        this.svcMessageBox.showSuccess('Das Dokument wurde erfolgreich gespeichert.', 'Erfolgreich');
                        await this.documentManagementService.remove(doc.documentID);
                        if (doc) {
                            doc.lastModified = new Date(saveRes.timestamp);
                            doc.fileName = saveRes.fileName;
                        }
                        this.docService.setDocumentInfo(doc);
                        await this.docService.replaceDokumentInDB(pdf, true);
                        this.hasChanges = false;

                        resolve(true);
                    },
                    error: async (saveError) => {
                        const errorResult = await this.handleSaveError(saveError, doc, pdf, true);
                        await this.docService.replaceDokumentInDB(pdf, false);
                        resolve(errorResult);
                    }
                });
            });
            // For some reason fox it failed loading when the pdf is given directly but not when its freshly downloaded again
            // chrome did not have that issue on PC/Android but on IOS too
            // its quite likely something in the foxit wasm so we use this workaround
            if (this.platform.IOS || this.platform.SAFARI) {
                return await this.loadDocumentFromOnline(documentID);
            }
            return await this.setup(pdf);
        }
        return await this.loadDocumentFromOnline(documentID);
    }

    async loadDocumentFromOnline(documentID: string): Promise<void> {
        const doc = await this.docService.getDocument(documentID);
        if (doc != null && doc.file.size > 0) {
            this.docService.setDocumentInfo(doc);
            await this.setup(doc.file);
        } else {
            this.svcMessageBox.showError('Die gewünschte Datei konnte nicht heruntergeladen werden!!', '!! FEHLER !!');
            if (this.pdfuiInstance) {
                await this.close();
            }
            await this.router.navigate([this.returnUrl]);
        }
    }

    ngOnDestroy(): void {
        this.windowFunctions.forEach((entry) => {
            window.removeEventListener(entry.e, entry.f);
        });

        this.objectUrls.forEach(url => {
            URL.revokeObjectURL(url);
        });
    }

    async setup(pdf: Blob): Promise<void> {
        this.currentUser = this.userAuthService.currentUserInfo.clearName;
        this.pdfuiInstance.changeLanguage('de-DE');
        this.pdfuiInstance.getViewModeManager().then(viewModeManger => viewModeManger.switchTo('continuous-view-mode'));

        this.pdfuiInstance.setDefaultMeasurementRatio({
            userSpaceScaleValue: 1, userSpaceUnit: (PDFViewCtrl.PDF.annots.constant.Annot_Unit_Type as any).cm as any, realScaleValue: 1, realUnit: (PDFViewCtrl.PDF.annots.constant.Annot_Unit_Type as any).cm as any,
        });
        window.pdfUIInstance = this.pdfuiInstance;
        this.annotationStorage.setColor(4278190080, 'ink', 'backgroundColorSettings');

        this.viewer = await this.pdfuiInstance.getPDFViewer();
        // awaiting here caused an issue (in at least v9) but I don't remember what it was back then so im leaving this as a comment
        // tho it doesn't seem to cause one in v11 anymore
        await this.viewer.setUserName(this.currentUser);

        this.setupDocumentsSidebar();
        this.viewer.getEventEmitter().on(PDFViewCtrl.constants.ViewerEvents.beforeLoadPDFDoc as any, async (type, ...args) => {
            const setBoxEraser = this.createSettingsBox(document.getElementById('eraser-tool') as HTMLInputElement, [this.eraserSettings], 'eraserSettings');

            const setBoxPencil = this.createSettingsBox(document.getElementById('pencil-tool') as HTMLInputElement, [this.inkSettings], 'inkSettings');

            document.getElementsByName('inkColorSettingsButton').forEach(element => {
                let color = '';
                switch (element.dataset.type) {
                    case 'ink':
                        break;
                    case 'marker':
                        break;
                    case 'forms':
                        break;
                    case 'text':
                    default:
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().freetextFreeTextCallout.defaultAppearance.textColor);
                        break;
                }

                element.style.backgroundColor = color;
                element.style.borderColor = color;
                (element as HTMLInputElement).onclick = (ev) => {
                    this.openColorSettings(null as any, 'borderColorSettings', null);
                    this.openColorSettings(null as any, 'backgroundColorSettings', null);
                    this.openColorSettings(ev, 'inkColorSettings', element.dataset.type);
                };
            });

            document.getElementsByName('borderColorSettingsButton').forEach(element => {
                let color = '';
                switch (element.dataset.type) {
                    case 'ink':
                        break;
                    case 'marker':
                        break;
                    case 'forms':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().square.color);
                        break;
                    case 'text':
                    default:
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().freetextFreeTextCallout.color);
                        break;
                }

                element.style.borderColor = color;
                (element as HTMLInputElement).onclick = (ev) => {
                    this.openColorSettings(null as any, 'inkColorSettings', null);
                    this.openColorSettings(null as any, 'backgroundColorSettings', null);
                    this.openColorSettings(ev, 'borderColorSettings', element.dataset.type);
                };
            });

            document.getElementsByName('backgroundColorSettingsButton').forEach(element => {
                let color: string;
                switch (element.dataset.type) {
                    case 'ink':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().ink.fillColor);
                        break;
                    case 'marker':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().highlightArea.fillColor);
                        break;
                    case 'forms':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().square.fillColor);
                        break;
                    case 'text':
                    default:
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().freetextFreeTextCallout.fillColor);
                        break;
                }

                element.style.backgroundColor = color;
                element.style.borderColor = '#000000';
                (element as HTMLInputElement).onclick = (ev) => {
                    this.openColorSettings(null as any, 'inkColorSettings', null);
                    this.openColorSettings(null as any, 'borderColorSettings', null);
                    this.openColorSettings(ev, 'backgroundColorSettings', element.dataset.type);
                };
            });

            const inkSettingBoxHandlerFunction = (e: any) => this.handleColorSettingBoxes(e, 'inkColorSettings');
            this.windowFunctions.push({t: window, e: 'click', f: inkSettingBoxHandlerFunction});
            this.windowFunctions.push({t: window, e: 'touchstart', f: inkSettingBoxHandlerFunction});
            window.addEventListener('click', inkSettingBoxHandlerFunction);
            window.addEventListener('touchstart', inkSettingBoxHandlerFunction);

            const borderColorHandlerFunction = (e: any) => this.handleColorSettingBoxes(e, 'borderColorSettings');
            this.windowFunctions.push({t: window, e: 'click', f: borderColorHandlerFunction});
            this.windowFunctions.push({t: window, e: 'touchstart', f: borderColorHandlerFunction});
            window.addEventListener('click', borderColorHandlerFunction);
            window.addEventListener('touchstart', borderColorHandlerFunction);

            const backgroundColorHAndlerFUnction = (e: any) => this.handleColorSettingBoxes(e, 'backgroundColorSettings');
            this.windowFunctions.push({t: window, e: 'click', f: backgroundColorHAndlerFUnction});
            this.windowFunctions.push({t: window, e: 'touchstart', f: backgroundColorHAndlerFUnction});
            window.addEventListener('click', backgroundColorHAndlerFUnction);
            window.addEventListener('touchstart', backgroundColorHAndlerFUnction);

            let conf: any = localStorage.getItem('pdf-color-picker-config');
            if (conf) {
                conf = JSON.parse(conf);
                const inkSettingsColorFields = document.getElementById('inkColorSettings')?.children[0].children[0];
                if (inkSettingsColorFields) {
                    for (let i = 0; i < 3; i++) {
                        const e = inkSettingsColorFields.getElementsByClassName('set-cust-' + i)[0] as HTMLElement;
                        e.style.backgroundColor = conf['set-cust-' + i];
                        e.style.borderColor = conf['set-cust-' + i];
                    }
                }
            }

            const confTypes = ['forms', 'ink', 'marker', 'text'];
            confTypes.forEach(t => {
                conf = localStorage.getItem('pdf-background-color-picker-config' + '_' + t);
                if (conf) {
                    conf = JSON.parse(conf);
                    const nrOfCustomColors = conf['set-cust-4'] !== 0 ? 4 : 3;
                    const settingsBoxes = Array.from(document.querySelectorAll('[data-setting=backgroundColorSettings]') as any) as any;
                    const SettingsColorFields = settingsBoxes.find(element => element.dataset.type === t).children[0].children[0];
                    for (let i = 0; i < nrOfCustomColors; i++) {
                        const e = SettingsColorFields.getElementsByClassName('set-cust-' + i)[0] as HTMLElement;
                        e.style.backgroundColor = conf['set-cust-' + i];
                        e.style.borderColor = conf['set-cust-' + i];
                    }
                }
            });

            ['text', 'form'].forEach(t => {
                conf = localStorage.getItem('pdf-border-color-picker-config' + '_' + t);
                if (conf) {
                    conf = JSON.parse(conf);
                    const nrOfCustomColors = conf['set-cust-4'] !== 0 ? 4 : 3;
                    const settingsBoxes = Array.from(document.querySelectorAll('[data-setting=borderColorSettings]') as any) as any;
                    const SettingsColorFields = settingsBoxes.find((element: any) => element.dataset.type === t).children[0].children[0];
                    for (let i = 0; i < nrOfCustomColors; i++) {
                        const e = SettingsColorFields.getElementsByClassName('set-cust-' + i)[0] as HTMLElement;
                        e.style.backgroundColor = conf['set-cust-' + i];
                        e.style.borderColor = conf['set-cust-' + i];
                    }
                }
            });

            ['text'].forEach(t => {
                conf = localStorage.getItem('pdf-color-picker-config' + '_' + t);
                if (conf) {
                    conf = JSON.parse(conf);
                    const nrOfCustomColors = conf['set-cust-4'] !== 0 ? 4 : 3;
                    const settingsBoxes = Array.from(document.querySelectorAll('[data-setting=inkColorSettings]') as any) as any;
                    const SettingsColorFields = settingsBoxes.filter(element => element.dataset.type === t)[0].children[0].children[0];
                    for (let i = 0; i < nrOfCustomColors; i++) {
                        const e = SettingsColorFields.getElementsByClassName('set-cust-' + i)[0] as HTMLElement;
                        e.style.backgroundColor = conf['set-cust-' + i];
                        e.style.borderColor = conf['set-cust-' + i];
                    }
                }
            });

            conf = this.annotationStorage.getConfig();
            if (this.inkSettings) {
                (this.inkSettings.nativeElement.children[0].children[1] as HTMLInputElement).value = '' + (conf.ink.opacity * 100);
                (this.inkSettings.nativeElement.children[0].children[2] as HTMLInputElement).value = '' + (conf.ink.opacity * 100);

                (this.inkSettings.nativeElement.children[1].children[1] as HTMLInputElement).value = conf.ink.borderInfo.width;
                (this.inkSettings.nativeElement.children[1].children[2] as HTMLInputElement).value = conf.ink.borderInfo.width;
            }

            let prevState = '';
            this.viewer.getEventEmitter().on(PDFViewCtrl.constants.ViewerEvents.switchStateHandler as any, (NewStateHandlerClass, OldStateHandlerClass) => {
                this.hasChanges = true;
                const name = OldStateHandlerClass.getStateName();
                prevState = NewStateHandlerClass.getStateName();

                this.openColorSettings(null as any, 'inkColorSettings', '');
                this.openColorSettings(null as any, 'borderColorSettings', '');
                this.openColorSettings(null as any, 'backgroundColorSettings', '');

                switch (name) {
                    case 'eraser':
                        this.handleBox(null, '', setBoxEraser);
                        break;
                    case 'createPencil':
                        this.handleBox(null, '', setBoxPencil);
                        break;
                    case 'createDistance':
                    case 'createPerimeter':
                    case 'createArea':
                    case 'createCircleArea':
                        this.pdfuiInstance.getComponentByName('sidebar-right').then((rightPanel) => {
                            rightPanel.show();
                        });
                        this.pdfuiInstance.getComponentByName('sidebar-right-tabs').then((tabs: any) => {
                            tabs.openTab('edit-properties-panel');
                            tabs.setActivetab('edit-properties-panel');
                            return this.pdfuiInstance.getComponentByName('edit-properties').then((component: any) => {
                                return component.setHost({}, 7);
                            });
                        });
                        break;
                }

                switch (prevState) {
                    case 'eraser':
                        this.setBoxVisible(setBoxEraser);
                        break;
                    case 'createPencil':
                        this.setBoxVisible(setBoxPencil);
                        break;
                }
            });

            document.getElementById('undoButton')?.addEventListener('click', async () => {
                await this.pdfuiInstance.callAddonAPI('UndoRedoAddon', 'undo', []);
            });

            document.getElementById('redoButton')?.addEventListener('click', async () => {
                await this.pdfuiInstance.callAddonAPI('UndoRedoAddon', 'redo', []);
            });

            document.getElementById('save-file-button')?.addEventListener('click', async () => {
                await this.savePDF();
            });

            document.getElementById('close-file-button')?.addEventListener('click', async () => {
                await this.showCloseOrSaveDialog();
            });

            document.getElementById('addBlankPage')?.addEventListener('click', (ev) => this.addBlankPage(this.pdfuiInstance));
            document.getElementById('removePage')?.addEventListener('click', (ev) => this.removePage());

            this.viewer.setDefaultAnnotConfig((type, intent) => {
                const name = intent ? type + intent : type;
                const config = this.annotationStorage.getSubConfig(name);
                return config[name];
            });

            this.stateHandlerManager = await this.pdfuiInstance.getStateHandlerManager();

            this.viewer.getEventEmitter().on(PDFViewCtrl.PDF.constant.DataEvents.annotationAdded as any, (annotations) => {
                this.hasChanges = true;
                if (['stamp', 'polygon', 'square', 'circle', 'line', 'polyline'].includes(annotations[0].info.type)) {
                    this.stateHandlerManager.switchTo('HandController');
                }
            });

            this.localStorageService.get('handBlockerActivated', 'SwissWebConfigDB', false, this.handBlockerActivated).then((res) => {
                const e = document.getElementById('handBlocker');
                if (e instanceof HTMLInputElement) {
                    e.checked = res;
                    this.handBlockerActivated = res;
                }
            });

            this.localStorageService.get('handBlockerSide', 'SwissWebConfigDB', false, 'right').then((res) => {
                const e = document.getElementById('handBlockerSide');
                if (e instanceof HTMLInputElement) {
                    if (res === 'left') {
                        this.switchHandBlockerSide();
                        e.checked = false;
                    } else {
                        e.checked = true;
                    }
                }
            });

            this.localStorageService.get('handBlockerSize', 'SwissWebConfigDB', false, 0).then((res) => {
                this.blockerSize = parseInt(res, 10);
                const c = this.getBlockerSize(this.blockerSize);
                this.setBlockerSize(c);
            });

            document.getElementById('pencil-tool')?.addEventListener('click', (e: any) => {
                if (e.target.parentElement.ariaPressed === 'true' && this.handBlockerActivated) {
                    this.activateBlocker();
                } else {
                    this.deactivateBlocker();
                }
            });

            document.getElementById('hand-tool')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('hand-tool-header')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('eraser-tool')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('create-custom-image')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('create-custom-image-camera')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('text-tab-li')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('marker-tab-li')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('forms-tab-li')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('stamp-tab-li')?.addEventListener('click', (e: any) => {
                this.deactivateBlocker();
            });

            document.getElementById('handBlockerText')?.addEventListener('click', (e: any) => {
                document.getElementById('handBlocker')?.click();
            });

            document.getElementById('handBlocker')?.addEventListener('change', (e: any) => {
                this.handBlockerActivated = e.target.checked;
                if (document.getElementById('pencil-tool')?.ariaPressed === 'true' && this.handBlockerActivated) {
                    this.activateBlocker();
                } else {
                    this.deactivateBlocker();
                }
                this.localStorageService.add('handBlockerActivated', this.handBlockerActivated, 'SwissWebConfigDB');
            });

            document.getElementById('hand-blocker-area')?.addEventListener('touchstart  ', (e: any) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            });

            document.getElementById('handBlockerSideElement')?.addEventListener('change', (e: any) => {
                this.switchHandBlockerSide();
            });

            document.getElementById('increaseBlockerSize')?.addEventListener('click', (e: any) => {
                this.increaseBlockerSize();
            });

            document.getElementById('decreaseBlockerSize')?.addEventListener('click', (e: any) => {
                this.decreaseBlockerSize();
            });

            /**/
            document.getElementById('uploadPic')?.addEventListener('change', (e: any) => {
                this.hasChanges = true;
                if (e.target.files[0]) {
                    const file = (document.getElementById('uploadPic') as any).files[0];
                    this.createImageStamp(file);
                }
            });

            document.getElementById('uploadPicCamera')?.addEventListener('change', (e: any) => {
                this.hasChanges = true;
                if (e.target.files[0]) {
                    const file = (document.getElementById('uploadPicCamera') as any).files[0];
                    this.createImageStamp(file);
                }
            });

            document.getElementById('create-custom-image')?.addEventListener('click', () => {
                document.getElementById('uploadPic')?.click();
            });

            document.getElementById('create-custom-image-camera')?.addEventListener('click', () => {
                if (!this.deviceDetectionService.getDevice().device.type) {
                    this.openCameraDialog();
                } else {
                    document.getElementById('uploadPicCamera')?.click();

                }
            });

            document.getElementById('text-size-input')?.addEventListener('change', (ev) => {
                this.textSizeChanged(ev);
            });

            document.getElementById('text-size-slider')?.addEventListener('change', (ev) => {
                this.textSizeChanged(ev);
            });

            document.getElementById('text-font-select')?.addEventListener('change', (ev) => {
                this.textFontChanged(ev);
            });

            conf = this.annotationStorage.getConfig();
            document.getElementsByName('inkColorSettingsButton').forEach(btn => {
                let color = '';
                switch (btn.dataset.type) {
                    case 'ink':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().ink.color);
                        break;
                    case 'marker':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().highlightArea.color);
                        break;
                    case 'forms':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().square.fillColor);
                        break;
                    case 'text':
                    default:
                        color = this.annotationStorage.intToHexColor(conf.freetextFreeTextTextbox.defaultAppearance.textColor);
                        break;
                }

                btn.style.backgroundColor = color;
                btn.style.borderColor = color;
            });

            document.getElementsByName('borderColorSettingsButton').forEach(btn => {
                let color: string;
                switch (btn.dataset.type) {
                    case 'ink':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().ink.fillColor);
                        break;
                    case 'marker':
                        color = this.annotationStorage.intToHexColor(this.annotationStorage.getConfig().highlightArea.fillColor);
                        break;
                    case 'forms':
                        color = this.annotationStorage.intToHexColor(conf.freetextFreeTextTextbox.color);
                        break;
                    case 'text':
                    default:
                        color = this.annotationStorage.intToHexColor(conf.freetextFreeTextTextbox.color);
                        break;
                }
                btn.style.borderColor = color;
            });

            document.getElementsByName('backgroundColorSettingsButton').forEach(btn => {
                let color: string;
                switch (btn.dataset.type) {
                    case 'ink':
                        color = this.annotationStorage.intToHexColor(conf.ink.color);
                        break;
                    case 'marker':
                        color = this.annotationStorage.intToHexColor(conf.highlightArea.color);
                        break;
                    case 'forms':
                        color = this.annotationStorage.intToHexColor(conf.square.fillColor);
                        if (color === '#ffffff') {
                            btn.classList.add('none');
                            btn.style.borderColor = '#000000';
                        }
                        break;
                    case 'text':
                    default:
                        color = this.annotationStorage.intToHexColor(conf.freetextFreeTextTextbox.fillColor);
                        break;
                }

                btn.style.backgroundColor = color;
                btn.style.borderColor = '#000000';
            });

            this.viewer.setEraserSize(20);
            await this.viewer.removeAnnotationIcon('stamp', 'Dynamic', '');
        });

        const self = this;
        const resizeHandlerFunction = (e) => this.handleResize(e);
        this.windowFunctions.push({t: window, e: 'resize', f: resizeHandlerFunction});
        window.addEventListener('resize', resizeHandlerFunction);

        window.onload = () => {
            if (UIExtension.PDFViewCtrl.DeviceInfo.isMobile) {
                return;
            }
            const touchHandlerFunction = (e: any) => self.handleTouch(e);
            self.windowFunctions.push({t: document, touchend: 'resize', f: touchHandlerFunction});
            document.addEventListener('touchend', touchHandlerFunction, false);
        };

        const pdfDoc = await this.pdfuiInstance.openPDFByFile(pdf);
        for (let i = 0; i < pdfDoc.getPageCount(); i++) {
            const page = await this.pdfuiInstance.getPDFPageRender(i);
            const pdfPage = await page?.getPDFPage();
            const annotations = await pdfPage?.getAnnots();
            annotations?.forEach(annot => {
                annot.setFlags(AnnotationFlags.Print);
            });
        }

        await pdfDoc?.getFile(
            {
                flags: 0,
                fileName: this.docService.getDocumentInfo().fileName
            },
            {
                progressHandler: {} as any // index.d.ts is wrong
            });
        this.hasLoaded = true;
    }

    async updateIndexDB(file: Blob, uploaded: boolean): Promise<void> {
        await this.docService.replaceDokumentInDB(file, uploaded);
    }

    async close(): Promise<void> {
        await this.closeDialog();
        await this.pdfuiInstance.close();
        if (this.viewer) {
            await this.viewer.close();
            this.viewer.destroy();
        }

        const dokuData = this.docService.getDocumentInfo();

        this.helperService.restartPeriodicalChecks();
        await this.helperService.setPageRefreshURL('internalRouting');
        switch (dokuData?.dokumentQuelle) {
            case DokumentModels.DokumentSource.SA_DBChecklisten:
            case DokumentModels.DokumentSource.SA_DBRapporte:
            case DokumentModels.DokumentSource.SA_DBDokumente:
                await this.router.navigate([this.saUrl, dokuData.objectID]);
                break;
            default:
                const currObjectID = this.svcObjekte.getCurrentObjectID();
                if (currObjectID) {
                    await this.router.navigate([this.objektUrl, currObjectID]);
                } else {
                    await this.router.navigate([this.timeappDocumentURL]);
                }
        }
    }

    async showCloseOrSaveDialog(): Promise<void> {
        if (this.hasLoaded) {
            if (this.hasChanges && this.closeEditorDialog) {
                document.body.appendChild(this.closeEditorDialog.nativeElement);
            } else {
                await this.close();
            }
        } else {
            await this.close();
        }
    }

    protected handleColorSets(ev: any, key: any, borderMode = 'inkColorSettings'): void {
        let type: any;
        if (ev.target instanceof SVGElement) {
            type = ev.target.parentElement.parentElement.parentElement.parentElement.dataset.type;
        } else {
            type = ev.target.parentElement.parentElement.parentElement.dataset.type;
        }
        this.annotationStorage.handleColorSets(ev, key, type, borderMode);
        this.openColorSettings(null as any, borderMode, null);
    }

    protected async cancelDeletePage(): Promise<void> {
        if (!this.deletePageDialog) {
            return;
        }
        this.deletePageTemplateContainer?.nativeElement.appendChild(this.deletePageDialog.nativeElement);
    }

    protected async deletePage(): Promise<void> {
        if (!this.deletePageDialog) {
            return;
        }
        const pdfDoc = await this.pdfuiInstance.getCurrentPDFDoc();
        if (pdfDoc && pdfDoc.getPageCount() > 1) {
            const pdfDocRender = await this.pdfuiInstance.getPDFDocRender();
            if (pdfDocRender) {
                await pdfDoc.removePage(pdfDocRender.getCurrentPageIndex());
                this.deletePageTemplateContainer?.nativeElement.appendChild(this.deletePageDialog.nativeElement);
            }
        }
    }

    protected async saveAndClose(): Promise<void> {
        if (this.hasLoaded) {
            const res = await this.savePDF();
            if (res) {
                await this.closeDialog();
                await this.close();
            }
        } else {
            await this.close();
        }
    }

    protected async closeDialog(): Promise<boolean> {
        this.closeEditorTemplateContainer?.nativeElement.appendChild(this.closeEditorDialog!.nativeElement);
        return true;
    }

    /* #region Events */
    protected async textSizeChanged(ev: any): Promise<void> {
        (document.getElementById('text-size-input') as HTMLInputElement)!.value = ev.target.value;
        (document.getElementById('text-size-slider') as HTMLInputElement)!.value = ev.target.value;

        this.annotationStorage.setTextSize(ev.target.value);
    }

    protected async textFontChanged(ev: any): Promise<void> {
        const config = this.annotationStorage.getConfig();

        const value = ev.target.value;
        config.freetextFreeTextCallout.defaultAppearance.font = value;
        config.freetextFreeTextTextbox.defaultAppearance.font = value;
        config.freetextFreeTextTypewriter.defaultAppearance.font = value;
    }

    protected async inkOpacityChanged(ev: any): Promise<void> {
        const type = 'ink';
        const config = this.annotationStorage.getSubConfig(type);
        const n = Number.parseInt((ev.target as any).value, 10);
        const arr = ev.target.parentElement.getElementsByTagName('input');
        for (let i = 0; i < arr.length; i++) {
            arr[i].value = n;
        }
        config[type].opacity = n / 100;
        localStorage.setItem('pdf-editor-config', JSON.stringify(config));
    }

    protected inkSizeChanged(ev: any): void {
        let value: number;
        let n: number;

        const target = ev.target.type;
        if (target === 'range') {
            value = Number.parseFloat((ev.target as any).value) / 10;
            n = value;
        } else {
            n = Number.parseFloat((ev.target as any).value);
            value = n * 10;
        }

        const arr = ev.target.parentElement.getElementsByTagName('input');
        for (const item of arr) {
            if (item.type !== target) {
                item.value = value;
            }
        }

        const config = this.annotationStorage.getSubConfig('ink');
        config.ink.borderInfo.width = n;
        localStorage.setItem('pdf-editor-config', JSON.stringify(config));
    }

    protected async eraserSizeChanged(ev: any): Promise<void> {
        const n = Number.parseInt((ev.target as any).value, 10);
        const arr = ev.target.parentElement.getElementsByTagName('input');
        for (const item of arr) {
            item.value = n;
        }
        this.viewer.setEraserSize(n);
    }

    protected async onApplyColor(event: any, key: string, borderMode: string, nrColors = 3): Promise<void> {
        let target: any;
        let type = '';
        document.querySelectorAll('[data-setting="' + borderMode + '"]').forEach((node: any) => {
            if (node.classList.contains('visible')) {
                target = node;
                type = node.dataset.type;
                key = key + '_' + type;
            }
        });
        let config: any = localStorage.getItem(key);
        if (!config) {
            config = {
                index: 1,
                'set-black': '',
                'set-white': '',
                'set-yellow': '',
                'set-green': '',
                'set-blue': '',
                'set-red': '',
                'set-none': 0,
                'set-cust-1': 0,
                'set-cust-2': 0,
                'set-cust-3': 0,
                'set-cust-4': 0,
                'set-cust-5': 0,
                'set-cust-6': 0,
                'set-cust-7': 0,
                'set-cust-8': 0,
            };
        } else {
            config = JSON.parse(config);
        }

        // for some reason 0 is not black in setDefaultAnnotConfig
        if (event.currentValue.hex === '#000000') {
            event.currentValue.hex = '#FF000000';
        }

        let slot: number = config.index || 0;
        if (event.currentValue.hex !== config['set-cust-' + (slot % nrColors)]) {
            slot = (slot + 1) % nrColors;
        }

        config.index = slot;
        config['set-cust-' + slot] = event.currentValue.hex;

        target.getElementsByClassName('set-cust-' + slot)[0].style.backgroundColor = event.currentValue.rgba;

        this.openColorSettings(null as any, borderMode, '');
        document.getElementsByName(borderMode + 'Button').forEach(e => {
            if (e.dataset.type === type) {
                if (borderMode === 'borderColorSettings') {
                    e.style.borderColor = event.currentValue.hex;
                } else {
                    e.style.backgroundColor = event.currentValue.hex;
                    e.style.borderColor = event.currentValue.hex;
                }
            }
        });

        localStorage.setItem(key, JSON.stringify(config));
        this.annotationStorage.setColor(parseInt(event.currentValue.hex.replace('#', '0x'), 16), type, borderMode);
    }

    private async createImageStamp(file): Promise<void> {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        this.objectUrls.push(objectUrl);

        const pdfDocRender = await this.pdfuiInstance.getPDFDocRender();
        if (!pdfDocRender) {
            throw new Error('Insert of image failed');
        }
        const currentPageIndex = pdfDocRender.getCurrentPageIndex();
        const pageRenderByPage = await this.pdfuiInstance.getPDFPageRender(currentPageIndex);
        if (!pageRenderByPage) {
            throw new Error('Insert of image failed');
        }
        const page = await pageRenderByPage.getPDFPage();
        const pageIndex = page.getIndex();
        const rotation = page.getRotation();
        img.onload = async () => {
            URL.revokeObjectURL(objectUrl);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                throw new Error('Insert of image failed');
            }

            const isPortrait = page.getWidth() <= page.getHeight();
            const SCALED_MAX_IMG_WIDTH = (isPortrait ? MAX_IMG_WIDTH : MAX_IMG_HEIGHT);
            const SCALED_MAX_IMG_HEIGHT = (isPortrait ? MAX_IMG_HEIGHT : MAX_IMG_WIDTH);

            let widthRect = Math.min(img.width, SCALED_MAX_IMG_WIDTH); // x
            let heightRect = Math.min(img.height, SCALED_MAX_IMG_HEIGHT); // 957

            if (img.width > SCALED_MAX_IMG_WIDTH || img.height > SCALED_MAX_IMG_HEIGHT) {
                // scaling required
                const widthRatio = SCALED_MAX_IMG_WIDTH / img.width;
                const heightRatio = SCALED_MAX_IMG_HEIGHT / img.height;

                if (widthRatio <= heightRatio) {
                    heightRect = img.height * widthRatio;
                } else {
                    widthRect = img.width * heightRatio;
                }
            }

            const deviceRect = {
                left: 0, right: widthRect, top: 0, bottom: heightRect,
            };

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-rotation * 90 * Math.PI / 180);

            if (isPortrait) {
                ctx.drawImage(img, -canvas.width / 2, -canvas.height / 2, canvas.width, canvas.height);
            } else {
                ctx.drawImage(img, -canvas.height / 2, -canvas.width / 2, canvas.height, canvas.width);
            }

            const dataURL = canvas.toDataURL();
            const rect = page.reverseDeviceRect(deviceRect, 1);

            const undoRedoAddon = await window.pdfUIInstance.getAddonInstance('UndoRedoAddon');
            if (undoRedoAddon) {
                (undoRedoAddon as any).invoke(async (pdfDoc) => {
                    const pageByIndex = await pdfDoc.getPageByIndex(pageIndex);
                    const annotations = await pageByIndex.addAnnot({
                        type: PDFViewCtrl.PDF.annots.constant.Annot_Type.stamp, rect, iconInfo: {
                            annotType: 'stamp', category: 'category', name: Date.now().toString(), fileType: 'png', url: dataURL,
                        }
                    });
                    // should be one but who knows
                    (document.getElementById('uploadPic') as any).value = '';
                    annotations.forEach(annot => {
                        this.pdfuiInstance.getEventEmitter().then((eventEmitter: any) => {
                            eventEmitter.emit('add-annot-success', annot);
                            annot.setFlags(AnnotationFlags.Print);
                        });
                    });
                });
            } else {
                page.addAnnot({
                    type: PDFViewCtrl.PDF.annots.constant.Annot_Type.stamp, rect, iconInfo: {
                        annotType: 'stamp', category: 'category', name: Date.now().toString(), fileType: 'png', url: dataURL,
                    }
                }).then((annotations) => {
                    // should be one but who knows
                    (document.getElementById('uploadPic') as any).value = '';
                    annotations.forEach(annot => {
                        this.pdfuiInstance.getEventEmitter().then((eventEmitter: any) => {
                            eventEmitter.emit('add-annot-success', annot);
                            annot.setFlags(AnnotationFlags.Print);
                        });
                    });
                });
            }

        };

        img.src = objectUrl;
    }

    private handleColorSettingBoxes(ev: any, id: string): void {
        const settingsBoxes = document.querySelectorAll('[data-setting=' + id + ']') as any;
        settingsBoxes.forEach((node: HTMLElement) => {
            // Body gets clicked when the color picker selection mouseEnd event gets triggered
            if (!(ev.target instanceof HTMLBodyElement)) {
                if (!ev || !node.contains(ev.target)) {
                    return node.classList.remove('visible');
                }
            }
        });
    }

    private openColorSettings(ev: MouseEvent, id: string, type: string | undefined | null): void {
        const header = document.getElementById('fv--mobile-toolbar-tabs');
        if (!header) {
            return;
        }

        const settingsBoxes = document.querySelectorAll('[data-setting=' + id + ']') as any;
        if (!ev) {
            settingsBoxes.forEach((node: HTMLElement) => node.classList.remove('visible'));
            return;
        }

        settingsBoxes.forEach((node: HTMLElement) => {
            if (node.dataset.type === type) {
                if (node.classList.contains('visible')) {
                    node.classList.remove('visible');
                } else {
                    node.classList.add('visible');

                    setTimeout(() => {
                        const settingsBoxSize = node.getBoundingClientRect();
                        const rect = (ev.target as HTMLElement).getBoundingClientRect();
                        const y = header.offsetTop + header.offsetHeight + rect.height;
                        const x = rect.left + (ev.target as HTMLElement).offsetLeft + rect.width / 2 - settingsBoxSize.width / 2;

                        node.style.top = y + 'px';
                        node.style.left = x + 'px';
                    }, 200);
                }
            } else {
                node.classList.remove('visible');
            }
        });
    }

    private handleTouch(event: any): void {
        this.lastTouchEnd = 0;
        const now = new Date().getTime();
        if (now - this.lastTouchEnd <= 300) {
            event.preventDefault();
        }
        this.lastTouchEnd = now;
    }

    private handleResize(e: any): void {
        this.pdfuiInstance.redraw().catch((err) => {
            console.log(err);
        });
    }

    private createSettingsBox(target, content, id): HTMLElement {
        let settingsBox = document.getElementById(id);
        const headerToolbar = document.getElementById('fv--mobile-toolbar-tabs');
        const header = document.querySelector('.fv__ui-mobile-header') as HTMLElement;
        if (!settingsBox) {
            settingsBox = document.createElement('div');

            settingsBox.id = id;
            settingsBox.classList.add('settingsBox');
            const pdfUIElement = document.getElementById('pdf-ui');
            if (pdfUIElement) {
                pdfUIElement.appendChild(settingsBox);
            }

            content.forEach((element: ElementRef) => {
                settingsBox?.appendChild(element.nativeElement);
            });
        }
        if (!settingsBox || !headerToolbar || !header) {
            throw new Error('Settings box could not be created');
        }

        setTimeout(() => {
            const rect = target.getBoundingClientRect();
            const settingsBoxSize = settingsBox.getBoundingClientRect();
            const y = header.offsetHeight + headerToolbar.offsetHeight + 5;
            const x = rect.left + rect.width / 2 - settingsBoxSize.width / 2 - settingsBoxSize.left;
            settingsBox.style.top = y + 'px';
            settingsBox.style.left = x + 'px';
        }, 200);

        const f = (e: any) => this.handleBox(e, id, settingsBox);
        this.windowFunctions.push({t: window, e: 'click', f});
        this.windowFunctions.push({t: window, e: 'touchstart', f});
        window.addEventListener('click', f);
        window.addEventListener('touchstart', f);

        return settingsBox;
    }

    private handleBox(e: any, id: string, settingsBox: HTMLElement): void {
        if (e === null || !(document.getElementById(id)?.contains(e.target as any))) {
            settingsBox.classList.remove('visible');
        }
    }

    private setBoxVisible(settingsBox: HTMLElement): void {
        if (settingsBox.classList.contains('visible')) {
            return settingsBox.classList.remove('visible');
        }

        document.querySelectorAll('.settingsBox').forEach((e) => {
            e.classList.remove('visible');
        });

        settingsBox.classList.add('visible');
    }

    private async savePDF(): Promise<boolean> {
        this.stateHandlerManager.switchTo('HandController');
        const pdfDoc = await this.pdfuiInstance.getCurrentPDFDoc();
        const file = await pdfDoc?.getFile(
            {
                flags: 0,
                fileName: this.docService.getDocumentInfo().fileName
            },
            {
                progressHandler: {} as any
            });
        if (!pdfDoc || !file) {
            return false;
        }
        const pdf = new File([file], 'untitled.pdf', {
            type: 'application/pdf'
        });
        const docInfo = this.docService.getDocumentInfo();
        const documentInfoWithFile = new DokumentModels.DocumentInfoWithFile(docInfo, file);

        return new Promise((resolve) => {
            this.docService.uploadDokumentWithInfo(pdf, docInfo).subscribe({
                next: async (res) => {
                    if (documentInfoWithFile) {
                        documentInfoWithFile.lastModified = new Date(res.timestamp);
                        documentInfoWithFile.fileName = res.fileName;
                    }
                    this.docService.setDocumentInfo(documentInfoWithFile);
                    await this.updateIndexDB(pdf, true);
                    this.hasChanges = false;
                    this.svcMessageBox.showSuccess('Das Dokument wurde erfolgreich gespeichert.', 'Erfolgreich');
                    resolve(true);
                }, error: async (err) => {
                    const res = await this.handleSaveError(err, docInfo, pdf, false);
                    await this.updateIndexDB(pdf, false);
                    this.hasChanges = false;
                    resolve(res);
                }
            });
        });
    }

    private async handleSaveError(err, docInfo, pdf, initalSync): Promise<boolean> {
        if (err.status === 409) {
            // conflict Detection
            const copyInfo = Object.assign({}, docInfo);
            copyInfo.documentID = uuidv4();
            copyInfo.fileName = copyInfo.fileName.substring(0, copyInfo.fileName.lastIndexOf('.')) + '_KOPIE' + copyInfo.fileName.substring(copyInfo.fileName.lastIndexOf('.'));
            copyInfo.description = copyInfo.description + ' KOPIE';
            copyInfo.lastModified = new Date(err.error.timestamp);
            let res = true;
            if (initalSync) {
                res = await this.svcMessageBox.showErrorOK('Es wird versucht eine Kopie %s anzulegen', '!! Versionskonflikt !!', [copyInfo.fileName]);
            } else {
                if (err.error.fileLocked) {
                    res = await this.svcMessageBox.askYesNoQuestion('Das Dokument kann nicht überschrieben werden. Soll eine Kopie angelegt werden?', '!! Dokument ist andernorts geöffnet !!', [copyInfo.fileName], undefined, undefined, undefined, 'Änderungen verwerfen und schliessen');
                } else {
                    res = await this.svcMessageBox.askYesNoQuestion('Ein Konflikt ist aufgetreten. Soll eine Kopie angelegt werden?', '!! Versionskonflikt !!', [copyInfo.fileName], undefined, undefined, undefined, 'Änderungen verwerfen und schliessen');
                }
            }
            if (res) {
                await new Promise((resolve) => {
                    this.docService.uploadDokumentWithInfo(pdf, copyInfo).subscribe({
                        next: async (saveRes) => {
                            await this.documentManagementService.remove(docInfo.documentID);
                            await this.documentManagementService.remove(copyInfo.documentID);
                            this.svcMessageBox.showSuccess('Das Dokument wurde erfolgreich gespeichert.', 'Erfolgreich');
                            docInfo.lastModified = new Date(saveRes.timestamp);
                            docInfo.fileName = saveRes.fileName;
                            this.docService.setDocumentInfo(docInfo);

                            await this.docService.replaceDokumentInDB(pdf, true);
                            this.hasChanges = false;

                            resolve(true);
                        }, error: async (saveError) => {
                            const errorResult = await this.handleSaveError(saveError, docInfo, pdf, true);
                            await this.docService.replaceDokumentInDB(pdf, false);
                            resolve(errorResult);
                        }
                    });
                });
            } else if (!initalSync) {
                await this.documentManagementService.remove(copyInfo.documentID);
                await this.close();
            }
            return true;
        }

        if (err.error?.code === 'IllegalFileName') {
            this.svcMessageBox.showInfoByLangagueKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
            err.status = 409;
            // remove all non assign chars
            docInfo.fileName = docInfo.fileName.replace(/[^\x20-\x7E]/g, '');
            return await this.handleSaveError(err, docInfo, pdf, initalSync);
        }
        if (err.name === 'TimeoutError' || err.status === 0 || err.status === HttpStatusCode.GatewayTimeout) {
            this.svcMessageBox.showInfo('Das Dokument konnte nicht hochgeladen werden. \n Es wird synchronisiert wenn Internet wieder zur verfügung steht', '!! INFO !!');
            await this.documentManagementService.addDocumentToSyncQueue(docInfo, pdf);
            this.hasChanges = false;
            return false;
        }

        if (!initalSync) {
            const userDownload = await this.svcMessageBox.askYesNoQuestion('Ein schwerwiegender Fehler ist aufgetreten! Speichern war unmöglich! Wollen Sie versuchen ihre Datei herunterzuladen?', 'Unbehandelter Fehler!!');
            if (userDownload) {
                const downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(pdf);
                downloadLink.setAttribute('download', docInfo.fileName);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                await this.documentManagementService.remove(docInfo.documentID);
                return true;
            }
        } else {
            this.svcMessageBox.showError('Das Dokument konnte aufgrund eines nicht abgehandelten Fehlers nicht gespeichert werden!!', '!! FEHLER !!');
        }
        return false;
    }

    private async addBlankPage(pdfuiInstance: any): Promise<void> {
        this.hasChanges = true;
        const pdfDoc = await pdfuiInstance.getCurrentPDFDoc();
        if (pdfDoc) {
            const page = await pdfDoc.getPageByIndex(0);
            const width = page.getWidth();
            const height = page.getHeight();
            await pdfDoc.insertPage(pdfDoc.getPageCount(), width, height);
            document.getElementById('gotoLastPage')?.click();
        }
    }

    private async removePage(): Promise<void> {
        if (!this.deletePageDialog) {
            return;
        }
        this.hasChanges = true;
        const pdfDoc = await this.pdfuiInstance.getCurrentPDFDoc();
        if (pdfDoc && pdfDoc.getPageCount() > 1) {
            document.body.appendChild(this.deletePageDialog.nativeElement);
        }
    }

    /* #endregion */

    private openCameraDialog(): void {
        if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
            const dialog = this.dialog.open(CameraViewerComponent, {
                maxWidth: '100vw',
                maxHeight: '100vh',
                data: {isDialogMode: false}
            });
            dialog.afterClosed().subscribe({
                next: (data) => {
                    if (data) {
                        this.createImageStamp(data.imageBlob);
                    }
                }
            });
        } else {
            this.svcMessageBox.showError('Keine Kamera Verfügbar', '!!Fehler!!');
        }
    }

    private activateBlocker(): void {
        const e = document.getElementById('hand-blocker-area');
        if (e) {
            e.classList.add('show');
        }
    }

    private deactivateBlocker(): void {
        const e = document.getElementById('hand-blocker-area');
        if (e) {
            e.classList.remove('show');
        }
    }

    private async switchHandBlockerSide(): Promise<void> {
        const e = document.getElementById('hand-blocker-area');
        if (e) {
            if (e.classList.contains('left')) {
                document.getElementById('hand-blocker-area')?.classList.remove('left');
                await this.localStorageService.add('handBlockerSide', 'right', 'SwissWebConfigDB');
            } else {
                document.getElementById('hand-blocker-area')?.classList.add('left');
                await this.localStorageService.add('handBlockerSide', 'left', 'SwissWebConfigDB');
            }
        }
    }

    private increaseBlockerSize(): void {
        if (this.blockerSize < 3) {
            this.blockerSize = this.blockerSize + 1;
            this.setBlockerSize(this.getBlockerSize(this.blockerSize));
            this.localStorageService.add('handBlockerSize', this.blockerSize, 'SwissWebConfigDB');
        }
    }

    private decreaseBlockerSize(): void {
        if (this.blockerSize > -3) {
            this.blockerSize = this.blockerSize - 1;
            this.setBlockerSize(this.getBlockerSize(this.blockerSize));
            this.localStorageService.add('handBlockerSize', this.blockerSize, 'SwissWebConfigDB');
        }
    }

    private getBlockerSize(n: number): string {
        switch (n) {
            case -3:
                return 'smallest';
            case -2:
                return 'smaller';
            case -1:
                return 'small';
            case 1:
                return 'large';
            case 2:
                return 'larger';
            case 3:
                return 'largest';
            default:
                return 'default-size';
        }
    }

    private setBlockerSize(classToSet: string): void {
        const e = document.getElementById('hand-blocker-area');
        e?.classList.remove('large', 'larger', 'largest', 'small', 'smaller', 'smallest');
        e?.classList.add(classToSet);
    }

    private setupDocumentsSidebar(): void {
        const docSidebar = document.getElementById('document-sidebar-content');
        if (docSidebar) {
            this.docService.getSidebarElements().forEach(pdf => {
                this.createSidebarPDFElement(pdf, docSidebar);
            });
            const activePDF = document.getElementById('pdf-selection-' + this.documentID);
            if (activePDF) {
                activePDF.classList.add('downloaded', 'selected');
            }
        }
    }

    private createSidebarPDFElement(pdf: DokumentInfo, docSideBar: HTMLElement): void {
        const container = document.createElement('div');
        container.innerText = pdf.description;
        container.classList.add('container');
        container.id = 'pdf-selection-' + pdf.documentID;
        container.addEventListener('click', () => {
            if (container.classList.contains('selected')) {
                return;
            }
            const currentActive = docSideBar.querySelector('.selected');
            currentActive?.classList.remove('selected');
            container.classList.add('downloaded', 'selected');
            this.switchPDF(pdf);
        });
        docSideBar.appendChild(container);
    }

    private async switchPDF(pdfData: DokumentInfo): Promise<void> {
        let success = true;
        if (this.hasChanges) {
            success = await this.savePDF();
        }
        if (!success) {
            return;
        }

        let doc = await this.documentManagementService.getDocument(pdfData.documentID);
        if (!doc) {
            doc = await this.docService.getDocument(pdfData.documentID);
        }

        if (doc) {
            this.docService.setPDFDokument(pdfData.objectID, doc.documentID, pdfData.fileName, pdfData.description, pdfData.dokumentTyp, pdfData.dokumentQuelle, pdfData.lastModified, this.docService.getSidebarElements());
            await this.pdfuiInstance.openPDFByFile(doc.file);
        } else {
            this.svcMessageBox.showError('FILE NOT FOUND', 'no file');
        }
    }
}
